// translated locale messages
export const messages = {
  de: {
    message: {
      sdb: 'Sicherheitsdatenblatt',
      sdbs: 'Liste der Sicherheitsdatenblätter',
      suche: 'Artikelnummer oder Bezeichnung',
      sdb_lc: 'Sprachauswahl SDB',
      sdb_nummer: 'Nummer',
      sdb_text: 'Bezeichnung',
      sdb_index: 'Index',
      sdb_glanzgrad: 'Glanzgrad',
      sdb_datum: 'Gültig ab',
      sdb_single_expand: '1 Eintrag erweiterbar',
      sdb_prior_btn: 'zurück',
      sdb_next_btn: 'vor',
      sdb_print: 'drucken',
      sdb_download: 'herunterladen',
      sdb_anzeigen: 'öffnen',
      sdb_navigation: 'NAVIGATION:',
      sdb_resize: 'Grösse ändern',
      sdb_filter: "Filter"
    },

    logging: {
      tryReadSDBItems             : 'reading sdb items list on {logvar1}',
      readSDBItems                : 'read sdb items list successfully',
      FailedReadSDBItems          : 'reading sdb items list failed',
      tryReadLanguageCountrys     : 'reading languages/countrys list on {logvar1}',
      readLanguageCountrys        : 'read languages/countrys list successfully',
      FailedReadLanguageCountrys  : 'reading languages/countrys list failed',
      sdbList                     : 'get sdb items list',
      tryReadSDB                  : 'reading sdb on {logvar1}',
      readSDB                     : 'read sdb successfully',
      FailedReadSDB               : 'reading sdb failed',
      readProductImage            : "read product image {logvar1}",
      readProductImageSuccess     : "read product image with size {logvar1}",
      readProductImageFailed      : "read product image failed"
      }
  },

  fr: {
    message: {
      sdb: 'Fiche de donnée de sécurité',
      sdbs: 'Liste des Fiches des données de sécurité',
      suche: "Numéro d'article ou texte d'article",
      sdb_lc: 'Langue SDB',
      sdb_nummer: 'Numéro',
      sdb_text: 'Texte',
      sdb_index: 'Index',
      sdb_glanzgrad: 'Degré de lustre',
      sdb_datum: 'Valable du',
      sdb_single_expand: '1 entrée extensible',
      sdb_prior_btn: 'Avant',
      sdb_next_btn: 'Suivant',
      sdb_print: 'Imprimer',
      sdb_download: 'Télécharger',
      sdb_anzeigen: 'Ouvrir',
      sdb_navigation: 'NAVIGATION:',
      sdb_resize: 'Redimensionner',
      sdb_filter: "Filtrer"
    },

    logging: {
      tryReadSDBItems             : 'reading sdb items list on {logvar1}',
      readSDBItems                : 'read sdb items list successfully',
      FailedReadSDBItems          : 'reading sdb items list failed',
      tryReadLanguageCountrys     : 'reading languages/countrys list on {logvar1}',
      readLanguageCountrys        : 'read languages/countrys list successfully',
      FailedReadLanguageCountrys  : 'reading languages/countrys list failed',
      sdbList                     : 'get sdb items list',
      tryReadSDB                  : 'reading sdb on {logvar1}',
      readSDB                     : 'read sdb successfully',
      FailedReadSDB               : 'reading sdb failed',
      readProductImage            : "read product image {logvar1}",
      readProductImageSuccess     : "read product image with size {logvar1}",
      readProductImageFailed      : "read product image failed"
      }

  },

  en: {
    message: {
      sdb: 'Security data sheet',
      sdbs: 'List of Security data sheets',
      suche: 'article number or description',
      sdb_lc: 'Language selection SDB',
      sdb_nummer: 'Number',
      sdb_text: 'Description',
      sdb_index: 'Index',
      sdb_glanzgrad: 'Gloss degree',
      sdb_datum: 'Valid from',
      sdb_single_expand: 'Single expand',
      sdb_prior_btn: 'Prior',
      sdb_next_btn: 'Next',
      sdb_print: 'Print',
      sdb_download: 'Download',
      sdb_anzeigen: 'Open',
      sdb_navigation: 'NAVIGATION:',
      sdb_resize: 'Resize',
      sdb_filter: "Filter"
    },

    logging: {
      tryReadSDBItems             : 'reading sdb items list on {logvar1}',
      readSDBItems                : 'read sdb items list successfully',
      FailedReadSDBItems          : 'reading sdb items list failed',
      tryReadLanguageCountrys     : 'reading languages/countrys list on {logvar1}',
      readLanguageCountrys        : 'read languages/countrys list successfully',
      FailedReadLanguageCountrys  : 'reading languages/countrys list failed',
      sdbList                     : 'get sdb items list',
      tryReadSDB                  : 'reading sdb on {logvar1}',
      readSDB                     : 'read sdb successfully',
      FailedReadSDB               : 'reading sdb failed',
      readProductImage            : "read product image {logvar1}",
      readProductImageSuccess     : "read product image with size {logvar1}",
      readProductImageFailed      : "read product image failed"
      }

  }
}
